import PlayerHeader from './component';

export default PlayerHeader;
